var _desc, _defs, _path, _path2, _rect, _path3, _circle, _path4, _circle2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Subscriptions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A subscription records sheet with a recurring renewal symbol.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sheetGradient",
    x1: 53,
    y1: 58,
    x2: 294,
    y2: 278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cycleGradient",
    x1: 201,
    y1: 179,
    x2: 311,
    y2: 289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cc68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f9d6b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h191l35 35v223H66c-10 0-18-8-18-18V60c0-10 8-18 18-18Z",
    fill: "#ffffff",
    stroke: "#8f9699",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257 42v35h35",
    fill: "none",
    stroke: "#8f9699",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 92,
    width: 122,
    height: 15,
    rx: 7.5,
    fill: "url(#sheetGradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 139h168M78 178h168M78 217h93",
    stroke: "#c7cbcd",
    strokeLinecap: "round",
    strokeWidth: 11
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 256,
    r: 12,
    fill: "#f89f1f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143 256h91",
    stroke: "#c7cbcd",
    strokeLinecap: "round",
    strokeWidth: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 228,
    r: 57,
    fill: "url(#cycleGradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280 214c-8-13-22-21-38-21-24 0-43 19-43 43s19 43 43 43c16 0 30-8 38-21",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeWidth: 11
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m274 195 8 19-21 2M230 277l-8-19 21-2",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.31d773df79760566ef9870dbcd2027fd.svg";
export { ForwardRef as ReactComponent };